import React from "react";

const stats = [
  { value: "900+", label: "Weddings Captured", testId: "stats-weddings-count" },
  { value: "07", label: "Industry Awards", testId: "stats-awards-count" },
  { value: "26", label: "Recommended Venues", testId: "stats-venues-count" },
  { value: "10+", label: "Years In Business", testId: "stats-years-count" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="border-b border-white/10 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10 border-x border-white/10">
        {stats.map((s) => (
          <div
            key={s.label}
            className="p-6 md:p-10 flex flex-col gap-2"
            data-testid={s.testId}
          >
            <span className="font-display font-black text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-none">
              {s.value}
            </span>
            <span className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.25em] text-white/55 mt-2">
              {s.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
